import * as React from 'react';

export type TDailyrentModalType = 'review' | 'booking' | null;

interface IDailyrentModalContext {
  activeModal: TDailyrentModalType;
  openModal(type: Exclude<TDailyrentModalType, null>): void;
  closeModal(): void;
}

interface IDailyrentModalProviderProps {
  children: React.ReactNode;
}

const DailyrentModalContext = React.createContext<IDailyrentModalContext | null>(null);

export const DailyrentModalProvider: React.FC<IDailyrentModalProviderProps> = ({ children }) => {
  const [activeModal, setActiveModal] = React.useState<TDailyrentModalType>(null);

  const openModal = React.useCallback((type: Exclude<TDailyrentModalType, null>) => {
    setActiveModal(type);
  }, []);

  const closeModal = React.useCallback(() => {
    setActiveModal(null);
  }, []);

  const contextValue = React.useMemo(
    () => ({ activeModal, openModal, closeModal }),
    [activeModal, openModal, closeModal],
  );

  return <DailyrentModalContext.Provider value={contextValue}>{children}</DailyrentModalContext.Provider>;
};

export const useDailyrentModal = (): IDailyrentModalContext => {
  const context = React.useContext(DailyrentModalContext);
  if (!context) {
    throw new Error('useDailyrentModal must be used within a DailyrentModalProvider');
  }

  return context;
};
